export default __webpack_public_path__ + "static/media/thumbs-up.ff7618bb.svg";